/**
 * Offer Types
 * All types related to offers and products
 */
/**
 * Redemption method types
 */
export var RedemptionMethodType;
(function (RedemptionMethodType) {
    RedemptionMethodType["FIXED_AMOUNT_OFF"] = "FIXED_AMOUNT_OFF";
    RedemptionMethodType["FIXED_PERCENTAGE_OFF"] = "FIXED_PERCENTAGE_OFF";
    RedemptionMethodType["VARIABLE_AMOUNT_OFF"] = "VARIABLE_AMOUNT_OFF";
    RedemptionMethodType["VARIABLE_PERCENTAGE_OFF"] = "VARIABLE_PERCENTAGE_OFF";
    RedemptionMethodType["FREE_SHIPPING"] = "FREE_SHIPPING";
})(RedemptionMethodType || (RedemptionMethodType = {}));
